import React from "react";

function LoginView({ handleGoogleLogin, handleLogout, isLoggedIn }) {
    return (
        <div className="login-view">
            <h2>{isLoggedIn ? "Welcome back!" : "Login with Google"}</h2>
            <button className="login-button" onClick={isLoggedIn ? handleLogout : handleGoogleLogin}>{isLoggedIn ? "Log out" : "Log in with Google"}</button>
        </div>
    );
}

export default LoginView;
